import _ from "lodash";

export default class ExpectedProp {
    public jsonProp: string;
    public modelProp: string;
    public type: string;

    constructor(jsonProp: string, modelProp: string, type: string) {
        this.jsonProp = jsonProp;
        this.modelProp = modelProp;
        this.type = type;
    }
}

export type SupportedProp = { propName: string, propType: 'string' | 'number' | 'array' | 'object' | 'boolean' | 'rgbArray' };

export function isExpectedProp(obj: any, propName: string, propType: 'string' | 'number' | 'array' | 'object' | 'boolean' | 'rgbArray'): boolean {
    if (_.has(obj, propName)) {
        const prop = obj[propName];
        switch (propType) {
            case 'string':
                return _.isString(prop);
            case 'number':
                return _.isNumber(prop);
            case 'array':
                return _.isArray(prop);
            case 'object':
                return _.isObject(prop);
            case 'boolean':
                return _.isBoolean(prop);
            case 'rgbArray':
                return _.isArray(prop) && prop.length === 3 && _.isNumber(prop[0]) && _.isNumber(prop[1]) && _.isNumber(prop[2]);
            default:
                break;
        }
    }

    return false;
}

export type AssertResult = { passed: boolean; validationError?: string; };

export function hasExpectedProps(obj: any, expectedProps: SupportedProp[]): { allPassed: boolean, results: AssertResult[] } {
    const results: AssertResult[] = expectedProps.map(expectedProp => isExpectedProp(obj, expectedProp.propName, expectedProp.propType) ?
        { passed: true } :
        { passed: false, validationError: `For '${expectedProp.propName}': expected '${expectedProp.propType}', got '${typeof obj['propName']}'` });

    return { allPassed: results.every(r => r.passed), results };
}

export function assertExpectedProps(obj: any, expectedProps: SupportedProp[], assertMessage?: string) {
    const assertResults = hasExpectedProps(obj, expectedProps);
    if (!assertResults.allPassed) {
        const message = assertMessage || 'Unexpected prop type(s) encountered.';
        console.error(message);
        console.log(assertResults.results.filter(r => !r.passed).map(r => r.validationError).join('\n'));
        console.log(obj);
        throw new Error(message);
    }
}
